module.exports = __webpack_public_path__ + "img/indisponivel.11b08844.svg";